import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { CommunityService } from "../../shared/services/community/community.service";
import { BillTypeService } from "./../../shared/bill/bill-type.service";
import { Subscription } from "rxjs/Subscription";
import { AuthService } from "../../shared/services/auth.service";
import { BackendService } from "../../shared/services/backend.service";

@Component({
  selector: "app-create-bill-type",
  templateUrl: "./create-bill-type.component.html",
  styleUrls: ["./create-bill-type.component.css"]
})
export class CreateBillTypeComponent implements OnInit, OnDestroy {
  bills: Array<any>;
  billName;
  community = [];
  communities: Array<any>;
  listedCommunities: Array<any>;
  tempBills: Array<string>;
  tempCommunities: Array<string>;
  modalMessage;
  modalTitle;
  notificationType;
  modalReference: NgbModalRef;
  routeSubscription: Subscription;
  communitiesSubscription: Subscription;
  activeRouteIndex: number;
  dropdownSettings = {};
  operatorId: string;

  constructor(
    private authService: AuthService,
    private communityService: CommunityService,
    private billTypeService: BillTypeService,
    private modalService: NgbModal,
    private route: ActivatedRoute
  ) {
    this.bills = [];
    this.billName = "";
    this.listedCommunities = [];
    this.tempBills = [];
    this.tempCommunities = [];
  }

  ngOnInit(): void {
    this.operatorId = BackendService.generateUserId(this.authService.getAuthState().email);
    this.communitiesSubscription = this.communityService.getCommunities().subscribe(communities => {
      this.communities = BackendService.sortRecords(communities, "name");
    });
    this.routeSubscription = this.route.params.subscribe(params => (this.activeRouteIndex = params.index));

    this.dropdownSettings = {
      singleSelection: false,
      text: "Select Communities",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      classes: "form-control fc-b s",
      labelKey: "name"
    };
  }

  ngOnDestroy(): void {
    this.communitiesSubscription.unsubscribe();
    this.routeSubscription.unsubscribe();
  }

  async addBill(notification): Promise<void> {
    if (!this.billName) {
      return;
    }
    const isBillTypeUnique = await new Promise<any>(resolve => {
      this.billTypeService.isBillTypeUnique(this.billName).then(result => {
        resolve(result && this.tempBills.indexOf(this.billName.toLowerCase()) === -1);
      });
    });
    if (isBillTypeUnique && !this.tempBills.includes(this.billName)) {
      this.bills.push({ name: this.billName, selected: false, communities: [], operatorId: this.operatorId });
      this.tempBills.push(this.billName);

      this.billName = "";
    } else {
      this.notify("error", "Oops!", this.billName + " already exists.", notification);
      this.billName = "";
    }
  }

  selectBill(index): void {
    this.bills[index].selected = !this.bills[index].selected;
  }

  removeBill(index): void {
    this.tempBills.splice(index, 1);
    this.bills.splice(index, 1);
  }

  addCommunity(notification): void {
    if (this.community.length === 0) {
      return;
    }

    this.community.forEach(element => {
      if (!this.tempCommunities.includes(element)) {
        this.listedCommunities.push({
          name: element.name,
          id: element.id
        });
        this.tempCommunities.push(element);
      } else {
        const message = element.name + " has been added already.";
        this.notify("error", "Oops!", message, notification);
      }
    });

    this.community = [];
  }

  removeCommunity(index): void {
    this.listedCommunities.splice(index, 1);
    this.tempCommunities.splice(index, 1);
  }

  saveBillWithoutCommunities(notification): void {
    if (this.listedCommunities.length === 0) {
      const message =
        "You are about to create bill types without sending them to a community. Would you like to proceed?";
      this.notify("warning", "Please note!", message, notification);
    } else {
      this.bills.forEach(element => {
        if (element.selected === true) {
          element.communities = this.listedCommunities;
        }
      });

      this.sendBill(notification);
    }
  }

  sendBill(notification): void {
    const message = this.listedCommunities.length > 0 ?
      "Bill created and sent successfully." : "Success! Bill created successfully";

    this.billTypeService.store(this.bills);
    this.bills = [];
    this.listedCommunities = [];
    this.tempCommunities = [];
    this.tempBills = [];

    this.notify("success", "Success!", message, notification);
  }

  notify(type, title, message, notification): void {
    this.notificationType = type;
    this.modalTitle = title;
    this.modalMessage = message;
    this.modalReference = this.modalService.open(notification, { size: "sm" });
  }

  close(): void {
    this.modalReference.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/bill/create-bill-type/create-bill-type.component.ts